/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
// @mui
import { Stack, Typography, Box, Container, Grid, Card, CardHeader, Button } from '@mui/material';
import { Helmet } from 'react-helmet-async';
// components
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import MultiSelector from '../components/multi-selector/multiSelector';
import VideoPlayer from '../components/video-player/videoPlayer';

export default function SensorVideoWall() {
  const sensorList = useSelector((state) => state.app.sensorList);
  const { adaptorType } = window;
  const [selectedSensorList, setSelectedSensorList] = useState([]);
  const [videoWallList, setVideoWallList] = useState([]);
  const [sensor, setSensor] = useState();
  const [inputValue, setInputValue] = useState('');
  const location = useLocation();

  useEffect(() => {
    window.liveStreamingSensors = selectedSensorList;
    return () => {
      window.LiveStreamingSensors = null;
    };
  }, [selectedSensorList]);

  const handleInputValue = (val) => {
    setInputValue(val);
  };

  const handleSelectedSensorListChange = (val) => {
    if (videoWallList.length > 0 && sensor != null) {
      handleStop();
    } else {
      setSelectedSensorList(val);
    }
  };

  const closeSensor = (sensor) => {
    const temp = selectedSensorList.filter((item) => item.sensorId !== sensor.sensorId);
    setSelectedSensorList(temp);
  };

  const handlePlay = () => {
    console.log('selectedSensorList', selectedSensorList);
    if (selectedSensorList.length > 0) {
      const camList = [];
      for (let i = 0; i < selectedSensorList.length; i += 1) {
        camList.push(selectedSensorList[i].sensorId);
      }
      const sensor = { name: `streams(${selectedSensorList.length})` };
      sensor.ip = selectedSensorList[0].ip;
      sensor.host = selectedSensorList[0].host;
      sensor.sensorId = 'composite-stream';
      setSensor(sensor);
      console.log('camList: ', camList);
      setVideoWallList(camList);
    } else {
      console.log('No streams selected');
    }
  };

  const handleStop = () => {
    setSensor(null);
    setVideoWallList([]);
    setSelectedSensorList([]);
  };

  const handleSelectAll = () => {
    const filterAuthorized = (sensorList) => sensorList
      .filter((sensor) => sensor.isAuthorized === true);
    setSelectedSensorList(filterAuthorized(availableSensors));
    setVideoWallList(filterAuthorized(availableSensors));
  };

  const shouldRender = videoWallList.length > 0 && sensor != null;

  // Filter out selected sensors from the sensorList
  const availableSensors = sensorList.filter(
    (sensor) => !selectedSensorList.some(selectedSensor => selectedSensor.sensorId === sensor.sensorId)
  );

  // Function to filter authorized sensors
  const filterAuthorized = (sensorList) => sensorList
    .filter((sensor) => sensor.isAuthorized === true);

  return (
    <div
      style={{
        display: location.pathname === '/vst/video-wall' ? 'inline' : 'none',
      }}
    >
      <Helmet>
        <title> stream </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          {'Video wall'}
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <CardHeader title={'Video wall'} subheader={'Select multiple streams then click on play'} />
              <Box sx={{ p: 3 }}>
                <Stack spacing={3} sx={{ mb: 2 }}>
                  <MultiSelector
                    id="video-wall-selector-multi"
                    placeholder="Type to search"
                    label={`Select ${adaptorType === 'streamer' ? 'files' : 'sensors'}`}
                    value={selectedSensorList}
                    inputValue={inputValue}
                    onInputChange={handleInputValue}
                    onChange={handleSelectedSensorListChange}
                    getOptionLabel={(option) => {
                      if (option.remoteDeviceName && option.remoteDeviceLocation) {
                        return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
                      } if (option.remoteDeviceName) {
                        return `${option.name} at ${option.remoteDeviceName}`;
                      }
                      return option.name;

                    }}
                    options={filterAuthorized(availableSensors)}
                  />
                </Stack>
                <Box display="flex" flexWrap="nowrap">
                  <Box m={1} display="flex" justifyContent="flex-start" alignItems="flex-start">
                    <Button variant="contained" onClick={handleSelectAll} sx={{ mr: 1 }}>
                      Select all
                    </Button>
                    <Button
                      variant="contained"
                      endIcon={shouldRender ? <StopIcon /> : <PlayArrowIcon />}
                      onClick={shouldRender ? handleStop : handlePlay}
                    >
                      {shouldRender ? 'Stop' : 'Start'}
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Card>
          </Grid>
          {shouldRender && (
            <Grid item xs={12}>
              <Typography variant="h5">{`Streams (${videoWallList.length})`}</Typography>
              <VideoPlayer
                sensor={sensor}
                videoWallList={videoWallList}
                sensorInRow={1}
                // key={`${sensor.sensorId + sensor.host + sensor.name}_vid_live`}
                page="video-wall"
                closeSensor={closeSensor}
                useVideoCoordinates
                onlyVideo
              />
            </Grid>
          )}
        </Grid>
      </Container>
    </div>
  );
}
